import type { TranslationMessages } from '../types';

export const reports_orders: TranslationMessages = {
      name: 'Báo cáo đơn hàng',
    };
